<template>
    <div class="map-post loading">
        <div class='map-post__slider'></div>
        <div class='content'>
            <div class='loading-line-1'></div>
            <div class='loading-line-2'></div>
            <div class='loading-line-3'></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            size: String,
        },
    }
</script>


<style lang="scss" scoped>
$grey: rgba(#E5C89A, 40%);


.map-post.loading {

    .map-post__slider {

        &::before {

            display: none;

        }

        &::after {

            content: ' ';
            display: block;
            width: 100%;
            height: auto;
            padding-top: 76.5151515%;
            background: $grey;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;

        }

    }

    .content {

        .loading-line-1 {

            width: 30px;
            height: 16px;
            background: $grey;

        }

        .loading-line-2 {

            width: 100px;
            height: 16px;
            background: $grey;
            margin-top: 16px;

        }

        .loading-line-3 {

            width: 188px;
            max-width: 100%;
            height: 16px;
            background: $grey;
            margin-top: 16px;

        }

    }

}


// .loading {
//     height: 85px;

//     &.small { 
//         padding: 14px 0;
//         height: 58px; 
//         padding-left: 38px;
//         background-image: none;
//     }
// }

// .loading-image {
//     position: absolute; 
//     top: 0;
//     left: 0;
//     width: 60px;
//     height: 60px;
//     border-radius: 50%;
//     background-image: radial-gradient(
//         circle calc(60px / 2), 
//         $grey 99%, 
//         transparent 0);

//     .small & {
//         height: 30px;
//         width: 30px;
//         top: 14px;
//     }   
// }

// .activity-item-header {
//     height: 15px;
//     background-image: linear-gradient($grey 32px, transparent 0);
    
//     .small & { height: 13px; }
// }

// .activity-item-content {
//     height: 45px;
//     background-image: linear-gradient($grey 32px, transparent 0);

//     .small & { height: 13px; margin-top: 5px; }
// }



</style>